import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { Information } from '../information';

@Component({
    selector: 'kiene-add-information-dialog',
    templateUrl: './add-information-dialog.component.html',
    styleUrls: ['./add-information-dialog.component.scss'],
})
export class AddInformationDialogComponent implements OnInit {
    information = new Information();

    constructor(
        private dialogRef: MatDialogRef<AddInformationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private api: KieneTableService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private messageService: MessageService,
    ) {
        if (data && data.information) {
            this.information = data.information;
        } else {
            this.information.gueltig_von = new Date();
        }
        if (data && data.informationstyp) {
            this.information.informationstyp = data.informationstyp;
        }
    }

    ngOnInit() {}

    save() {
        this.api.updateEntity(this.apiBaseUrl + 'information/update.php', this.information).subscribe(
            response => {
                this.messageService.infoMessage('Neue Information erfolgreich gespeichert!');
                this.dialogRef.close(response);
            },
            error => {
                this.messageService.errorMessage('Die Information konnte nicht gespeichert werden!', error);
            },
        );
    }

    cancel() {
        this.dialogRef.close(false);
    }
}
